import {NgModule} from '@angular/core';
import {AdapterArticlePipe} from './adapter-article.pipe';
import {SimpleImageVariantPipe} from '@tisa-group/core';

@NgModule({
  exports: [AdapterArticlePipe],
  declarations: [AdapterArticlePipe],
  providers: [SimpleImageVariantPipe],
})
export class AdapterArticleModule {}
